var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentResponceIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 19.6042H7.49935C2.97435 19.6042 1.04102 17.6708 1.04102 13.1458V8.14583C1.04102 3.62083 2.97435 1.6875 7.49935 1.6875H11.666C12.0077 1.6875 12.291 1.97083 12.291 2.3125C12.291 2.65417 12.0077 2.9375 11.666 2.9375H7.49935C3.65768 2.9375 2.29102 4.30417 2.29102 8.14583V13.1458C2.29102 16.9875 3.65768 18.3542 7.49935 18.3542H12.4993C16.341 18.3542 17.7077 16.9875 17.7077 13.1458V8.97917C17.7077 8.6375 17.991 8.35417 18.3327 8.35417C18.6743 8.35417 18.9577 8.6375 18.9577 8.97917V13.1458C18.9577 17.6708 17.0243 19.6042 12.4993 19.6042Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 9.60489H14.9993C12.1493 9.60489 11.041 8.49656 11.041 5.64656V2.31322C11.041 2.06322 11.191 1.82989 11.4243 1.73822C11.6577 1.63822 11.9243 1.69656 12.1077 1.87156L18.7743 8.53822C18.9493 8.71322 19.0077 8.98822 18.9077 9.22156C18.8077 9.45489 18.5827 9.60489 18.3327 9.60489ZM12.291 3.82156V5.64656C12.291 7.79656 12.8493 8.35489 14.9993 8.35489H16.8243L12.291 3.82156Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 12.1055H5.83398C5.49232 12.1055 5.20898 11.8221 5.20898 11.4805C5.20898 11.1388 5.49232 10.8555 5.83398 10.8555H10.834C11.1757 10.8555 11.459 11.1388 11.459 11.4805C11.459 11.8221 11.1757 12.1055 10.834 12.1055Z",
    fill: "#353535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16732 15.4375H5.83398C5.49232 15.4375 5.20898 15.1542 5.20898 14.8125C5.20898 14.4708 5.49232 14.1875 5.83398 14.1875H9.16732C9.50898 14.1875 9.79232 14.4708 9.79232 14.8125C9.79232 15.1542 9.50898 15.4375 9.16732 15.4375Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentResponceIcons);
export default __webpack_public_path__ + "static/media/documentResponceIcons.93fce5bbc2b2cde3f0eb3bf45071452e.svg";
export { ForwardRef as ReactComponent };